// rel="noopener" kept as in the design (noreferrer would hide the referrer from stores/WhatsApp)
/* eslint-disable react/jsx-no-target-blank */
import { useHomeText } from '../text';

const Demo = () => {
  const t = useHomeText();
  return (
    <section id="demo" style={{ maxWidth: "1280px", margin: "0 auto", padding: "104px 24px 40px", display: "flex", flexDirection: "column", gap: "40px", position: "relative" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end", gap: "24px", flexWrap: "wrap" }}>
        <div style={{ display: "flex", flexDirection: "column", gap: "12px", maxWidth: "680px" }}>
          <span style={{ fontWeight: "700", color: "#1E8F80", fontSize: "16px" }}>
            {t.demo.insideTheApp}
          </span>
          <h2 style={{ margin: "0", fontFamily: "'Baloo Bhaijaan 2', sans-serif", fontWeight: "800", fontSize: "clamp(34px, 4vw, 52px)", lineHeight: "1.2", width: "min(812px, calc(100vw - 48px))" }}>
            <blockquote dir={t.demo.aCompleteSafeWorldDir}>
              <p dir={t.demo.aCompleteSafeWorldDir}>
                <strong>
                  {t.demo.aCompleteSafeWorld}
                  <br />
                </strong>
              </p>
            </blockquote>
          </h2>
          <div style={{ display: "flex", alignItems: "center", gap: "14px", flexWrap: "wrap" }}>
            <img width="560" height="560" loading="lazy" decoding="async" src="/assets/img/boy-head.webp" alt="" style={{ width: "64px", height: "64px", borderRadius: "50%", objectFit: "cover", objectPosition: "50% 20%", background: "#141C63", border: "3px solid #46D3BE", boxShadow: "0 0 0 5px rgba(70,211,190,0.18)" }} />
            <p style={{ margin: "0", fontFamily: "'Baloo Bhaijaan 2', sans-serif", fontWeight: "800", fontSize: "clamp(24px, 2.6vw, 32px)", lineHeight: "1.3", color: "#141C63" }}>
              {t.demo.aSeriousGameWhere}
              <span style={{ display: "inline-block", padding: "0 14px", borderRadius: "14px", background: "#FFC93C", color: "#0B1240", boxShadow: "0 4px 0 #C48E00" }}>
                {t.demo.theHero}
              </span>
            </p>
          </div>
        </div>
        <a href="https://khotoua.com/KHOTOUA_DEMO/Khotoua%20Inscription%20Portrait.dc.html" target="_blank" rel="noopener" style={{ display: "inline-flex", alignItems: "center", minHeight: "56px", padding: "0 26px", borderRadius: "18px", background: "#141C63", color: "#FFFFFF", fontWeight: "800", fontSize: "17px", textDecoration: "none" }}>
          {t.demo.tryTheDemo}
        </a>
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(min(380px, 100%), 1fr))", gap: "20px", alignItems: "stretch" }}>
        <figure style={{ margin: "0", gridRow: "span 2", background: "#141C63", borderRadius: "32px", padding: "28px 24px", display: "flex", flexDirection: "column", alignItems: "center", gap: "18px", color: "#FFFFFF" }}>
          <div style={{ width: "280px", maxWidth: "100%", borderRadius: "40px", border: "8px solid #0B1240", overflow: "hidden", boxShadow: "0 30px 60px rgba(0,0,0,0.4)" }}>
            <img width="800" height="1734" loading="lazy" decoding="async" src="/assets/img/screen-welcome.webp" alt={t.demo.khotouaWelcomeScreenWelcomeAlt} style={{ width: "100%", display: "block" }} />
          </div>
          <figcaption style={{ display: "flex", flexDirection: "column", gap: "6px", textAlign: "center" }}>
            <strong style={{ fontSize: "22px" }}>
              {t.demo.welcome}
            </strong>
            <span style={{ fontSize: "15px", color: "#C9CEF5" }}>
              {t.demo.learningCulturePlayDiscovery}
            </span>
          </figcaption>
        </figure>
        <figure style={{ margin: "0", background: "#FFFFFF", border: "1px solid #E1E5F7", borderRadius: "28px", padding: "12px", display: "flex", flexDirection: "column", gap: "12px" }}>
          <img width="1600" height="738" loading="lazy" decoding="async" src="/assets/img/screen-trimesters.webp" alt={t.demo.chooseYourTermScreenAlt} style={{ width: "100%", borderRadius: "18px", display: "block" }} />
          <figcaption style={{ padding: "4px 10px 10px", display: "flex", flexDirection: "column", gap: "4px" }}>
            <strong style={{ fontSize: "19px" }}>
              {t.demo.inStepWithThe}
            </strong>
            <span style={{ fontSize: "15px", color: "#3A4270" }}>
              {t.demo.term1TheAdventure}
            </span>
          </figcaption>
        </figure>
        <figure style={{ margin: "0", background: "#FFFFFF", border: "1px solid #E1E5F7", borderRadius: "28px", padding: "12px", display: "flex", flexDirection: "column", gap: "12px" }}>
          <img width="1600" height="738" loading="lazy" decoding="async" src="/assets/img/screen-subjects.webp" alt={t.demo.chooseYourSchoolAdventureAlt} style={{ width: "100%", borderRadius: "18px", display: "block" }} />
          <figcaption style={{ padding: "4px 10px 10px", display: "flex", flexDirection: "column", gap: "4px" }}>
            <strong style={{ fontSize: "19px" }}>
              {t.demo.chooseYourSchoolAdventure}
            </strong>
            <span style={{ fontSize: "15px", color: "#3A4270" }}>
              {t.demo.arabicFrenchEnglishMaths}
            </span>
          </figcaption>
        </figure>
        <figure style={{ margin: "0", background: "#FFFFFF", border: "1px solid #E1E5F7", borderRadius: "28px", padding: "12px", display: "flex", flexDirection: "column", gap: "12px" }}>
          <img width="1600" height="738" loading="lazy" decoding="async" src="/assets/img/screen-games.webp" alt={t.demo.myGamesScreenMathsAlt} style={{ width: "100%", borderRadius: "18px", display: "block" }} />
          <figcaption style={{ padding: "4px 10px 10px", display: "flex", flexDirection: "column", gap: "4px" }}>
            <strong style={{ fontSize: "19px" }}>
              {t.demo.challengeAndCreativityAdventures}
            </strong>
            <span style={{ fontSize: "15px", color: "#3A4270" }}>
              {t.demo.mentalMathsMemory2048}
            </span>
          </figcaption>
        </figure>
        <figure style={{ margin: "0", background: "#FFFFFF", border: "1px solid #E1E5F7", borderRadius: "28px", padding: "12px", display: "flex", flexDirection: "column", gap: "12px" }}>
          <img width="1600" height="738" loading="lazy" decoding="async" src="/assets/img/screen-encyclopedia.webp" alt={t.demo.myEncyclopediaScreenInAlt} style={{ width: "100%", borderRadius: "18px", display: "block" }} />
          <figcaption style={{ padding: "4px 10px 10px", display: "flex", flexDirection: "column", gap: "4px" }}>
            <strong style={{ fontSize: "19px" }}>
              {t.demo.myEncyclopediaInAugmented}
            </strong>
            <span style={{ fontSize: "15px", color: "#3A4270" }}>
              {t.demo.theAnimalWorldA}
            </span>
          </figcaption>
        </figure>
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(min(560px, 100%), 1fr))", gap: "20px" }}>
        <figure style={{ margin: "0", background: "#FFFFFF", border: "1px solid #E1E5F7", borderRadius: "28px", padding: "12px", display: "flex", flexDirection: "column", gap: "12px" }}>
          <img width="1600" height="738" loading="lazy" decoding="async" src="/assets/img/screen-variety.webp" alt={t.demo.myDiscoveriesScreenVideosAlt} style={{ width: "100%", borderRadius: "18px", display: "block" }} />
          <figcaption style={{ padding: "4px 10px 10px", display: "flex", flexDirection: "column", gap: "4px" }}>
            <strong style={{ fontSize: "19px" }}>
              {t.demo.myDiscoveriesWhatWill}
            </strong>
            <span style={{ fontSize: "15px", color: "#3A4270" }}>
              {t.demo.videosToWatchAnd}
            </span>
          </figcaption>
        </figure>
        <figure style={{ margin: "0", background: "#FFFFFF", border: "1px solid #E1E5F7", borderRadius: "28px", padding: "12px", display: "flex", flexDirection: "column", gap: "12px" }}>
          <img width="1600" height="738" loading="lazy" decoding="async" src="/assets/img/screen-videos.webp" alt={t.demo.videosScreenIllustratedStoriesAlt} style={{ width: "100%", borderRadius: "18px", display: "block" }} />
          <figcaption style={{ padding: "4px 10px 10px", display: "flex", flexDirection: "column", gap: "4px" }}>
            <strong style={{ fontSize: "19px" }}>
              {t.demo.meaningfulIllustratedStories}
            </strong>
            <span style={{ fontSize: "15px", color: "#3A4270" }}>
              {t.demo.samiAndTheTwo}
            </span>
          </figcaption>
        </figure>
        <figure style={{ margin: "0", background: "#FFFFFF", border: "1px solid #E1E5F7", borderRadius: "28px", padding: "12px", display: "flex", flexDirection: "column", gap: "12px" }}>
          <img width="1600" height="738" loading="lazy" decoding="async" src="/assets/img/screen-avatar.webp" alt={t.demo.characterDesignScreenWithAlt} style={{ width: "100%", borderRadius: "18px", display: "block" }} />
          <figcaption style={{ padding: "4px 10px 10px", display: "flex", flexDirection: "column", gap: "4px" }}>
            <strong style={{ fontSize: "19px" }}>
              {t.demo.designYourCharacterAnd}
            </strong>
            <span style={{ fontSize: "15px", color: "#3A4270" }}>
              {t.demo.myBalanceThePrice}
            </span>
          </figcaption>
        </figure>
        <figure style={{ margin: "0", background: "#FFFFFF", border: "1px solid #E1E5F7", borderRadius: "28px", padding: "12px", display: "flex", flexDirection: "column", gap: "12px" }}>
          <img width="1600" height="738" loading="lazy" decoding="async" src="/assets/img/screen-sustainability-map.webp" alt={t.demo.mapOfTheSustainabilityAlt} style={{ width: "100%", borderRadius: "18px", display: "block" }} />
          <figcaption style={{ padding: "4px 10px 10px", display: "flex", flexDirection: "column", gap: "4px" }}>
            <strong style={{ fontSize: "19px" }}>
              {t.demo.theSustainabilityJourneyAround}
            </strong>
            <span style={{ fontSize: "15px", color: "#3A4270" }}>
              {t.demo.continentAfterContinentChildren}
            </span>
          </figcaption>
        </figure>
      </div>
    </section>
  );
};

export default Demo;
